import { useFormikContext } from 'formik';
import { FormFieldProps } from '../index';

export type EventWithTarget<T = unknown> = { target: { value: T; name?: string } };

export const useAdditionalOnChange = (
  baseOnChange: (event: EventWithTarget) => void,
  additionalOnChange: FormFieldProps['additionalOnChange']
): ((event: EventWithTarget) => void) => {
  const { setFieldValue } = useFormikContext();

  return (event) => {
    baseOnChange(event);
    additionalOnChange?.(event.target.value, setFieldValue);
  };
};
